export var MIDDLE_MOUSE_CLICK_BUTTON = 1;
export var isMiddleMouseClick = function isMiddleMouseClick(event) {
  return event.button === MIDDLE_MOUSE_CLICK_BUTTON;
};